import Favorite from '@mui/icons-material/Favorite';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import { memo, useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { apiURL } from '../../api';
import { OrderDeliveryMethodEnum } from '../../constants';
import { AuthContext } from '../../contexts/AuthContext';
import { CartContext } from '../../contexts/CartContext';
import { showToast } from '../../redux/actions';
import { createOrder } from '../../redux/actions/orders';

const Checkout = () => {
  const {
    authState: { user, isAuthenticated, authLoading },
  } = useContext(AuthContext);
  const {
    cartState: { cart },
    deleteCart,
  } = useContext(CartContext);
  const [total, setTotal] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState('stripePayment');
  const [valueDeliveryMethod, setValueDeliveryMethod] = useState(
    OrderDeliveryMethodEnum.GHN
  );
  const [note, setNote] = useState('');
  const [coinChecked, setCoinChecked] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (!authLoading && !isAuthenticated) {
    navigate(`/login?RedirectTo=${location.pathname}${location.search}`);
  } else if (
    !authLoading &&
    isAuthenticated &&
    (!user?.address || !user?.phone)
  ) {
    navigate(`/personal-info`);
  }

  const handleChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);

  const handleChangeDeliveryMethod = useCallback((event) => {
    setValueDeliveryMethod(event.target.value);
  }, []);

  const handleChangeNote = useCallback((event) => {
    setNote(event.target.value);
  }, []);

  useEffect(() => {
    if (deliveryFee === 0) {
      const handleDeliveryFee = async () => {
        axios.defaults.headers.common[
          'Token'
        ] = `${process.env.REACT_APP_GHN_TOKEN_API}`;
        axios.defaults.headers.common[
          'ShopId'
        ] = `${process.env.REACT_APP_GHN_SHOP_ID}`;
        const deliveryFeeApi = await axios.post(
          'https://dev-online-gateway.ghn.vn/shiip/public-api/v2/shipping-order/fee',
          {
            from_district_id: 1451,
            service_id: null,
            service_type_id: 2,
            to_district_id: user?.districtId ?? 1451,
            to_ward_code: user?.wardCode ?? '20901',
            height: 1,
            length: 1,
            weight: 1,
            width: 1,
            insurance_value: 1,
            coupon: null,
          }
        );
        setDeliveryFee(deliveryFeeApi.data.data || 0);
      };
      handleDeliveryFee();
    }

    return () => {
      delete axios.defaults.headers.common['Token'];
      delete axios.defaults.headers.common['ShopId'];
    };
  }, [deliveryFee, user?.districtId, user?.wardCode]);

  useEffect(() => {
    if (cart?.length > 0) {
      let sumTotal = 0;
      cart.forEach((item) => {
        sumTotal += item.total;
      });
      if (coinChecked) {
        // setTotal(total - (user?.coin <= total ? user?.coin : total));
        setTotal(
          (sumTotal || 0) -
            (user?.coin <= total ? user?.coin : total) +
            (deliveryFee?.total
              ? valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
                ? 0
                : deliveryFee?.total || 0
              : 0)
        );
      } else {
        setTotal(
          (sumTotal || 0) +
            (deliveryFee?.total
              ? valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
                ? 0
                : deliveryFee?.total || 0
              : 0)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, deliveryFee, valueDeliveryMethod]);

  useEffect(() => {
    if (coinChecked) {
      setTotal(total - (user?.coin <= total ? user?.coin : total));
    } else if (cart?.length > 0) {
      let sumTotal = 0;
      cart.forEach((item) => {
        sumTotal += item.total;
      });
      setTotal(
        (sumTotal || 0) +
          (deliveryFee?.total
            ? valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
              ? 0
              : deliveryFee?.total || 0
            : 0)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinChecked]);

  const onSubmitStripe = useCallback(async () => {
    // let a = document.createElement('a');
    // a.target = '_blank';
    // a.href = 'https://stripe.com/docs/testing';
    // if (
    //   window.confirm(
    //     'If you click "ok" you would be redirected to testing docs https://stripe.com/docs/testing'
    //   )
    // ) {
    //   a.click();
    // }
    const orderDetail = cart.map((item) => ({
      id: item.product.id,
      quantity: item.quantity,
      color: item.product.colors[0],
      size: item.product.sizes[0],
    }));
    const stripe = await loadStripe(process.env.REACT_APP_STRIPE_KEY);
    axios
      .post(`${apiURL}/orders/create-checkout-session`, {
        orderDetail,
        note: note ?? '',
        deliveryFee:
          valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
            ? 0
            : deliveryFee?.total || 0,
        isUseCoin: coinChecked,
        deliveryMethod: valueDeliveryMethod,
      })
      .then((response) => {
        deleteCart();
        stripe.redirectToCheckout({
          sessionId: response.data?.sessionId,
        });
      })
      .catch((err) => console.log(err));
  }, [
    cart,
    note,
    valueDeliveryMethod,
    deliveryFee?.total,
    coinChecked,
    deleteCart,
  ]);

  const onSubmitMomo = useCallback(() => {
    // let a = document.createElement('a');
    // a.target = '_blank';
    // a.href =
    //   'https://developers.momo.vn/v3/vi/docs/payment/onboarding/test-instructions';
    // if (
    //   window.confirm(
    //     'If you click "ok" you would be redirected to testing docs https://developers.momo.vn/v3/vi/docs/payment/onboarding/test-instructions'
    //   )
    // ) {
    //   a.click();
    // }
    const orderDetail = cart.map((item) => ({
      id: item.product.id,
      quantity: item.quantity,
      color: item.product.colors[0],
      size: item.product.sizes[0],
    }));
    axios
      .post(`${apiURL}/orders/momo-payment`, {
        orderDetail,
        note: note ?? '',
        deliveryFee:
          valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
            ? 0
            : deliveryFee?.total || 0,
        isUseCoin: coinChecked,
        deliveryMethod: valueDeliveryMethod,
      })
      .then((response) => {
        deleteCart();
        window.location.replace(response.data.payUrl);
      })
      .catch((err) => console.log(err));
  }, [
    cart,
    note,
    valueDeliveryMethod,
    deliveryFee?.total,
    coinChecked,
    deleteCart,
  ]);

  const onCheckout = useCallback(
    async (event) => {
      event.preventDefault();
      if (value !== 'paymentOnDelivery') {
        if (value === 'stripePayment') {
          await onSubmitStripe();
        } else if (value === 'momoPayment') {
          onSubmitMomo();
        }
      } else {
        const orderDetail = [];
        cart.forEach((item) => {
          orderDetail.push({
            id: item.product.id,
            quantity: item.quantity,
            color: item.product.colors[0],
            size: item.product.sizes[0],
          });
        });
        dispatch(
          createOrder.createOrderRequest({
            orderDetail,
            note,
            deliveryFee:
              valueDeliveryMethod === OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
                ? 0
                : deliveryFee?.total || 0,
            isUseCoin: coinChecked,
            deliveryMethod: valueDeliveryMethod,
          })
        );
        deleteCart();
        dispatch(
          showToast({
            message: 'Đã thêm vào đơn hàng',
            type: 'success',
          })
        );
        navigate('/products');
      }
    },
    [
      cart,
      coinChecked,
      deleteCart,
      deliveryFee?.total,
      dispatch,
      navigate,
      note,
      onSubmitMomo,
      onSubmitStripe,
      value,
      valueDeliveryMethod,
    ]
  );

  return (
    <>
      <section
        className="breadcrumb-section set-bg"
        style={{
          backgroundImage: `url(img/breadcrumb.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="breadcrumb__text">
                <h2>{t('checkout.title')}</h2>
                <div className="breadcrumb__option">
                  <Link to="/">{t('header.home')}</Link>
                  <span>{t('checkout.title2')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="checkout spad">
        <div className="container">
          <div className="checkout__form">
            <h4>{t('checkout.title3')}</h4>
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="checkout__input">
                    <p>
                      {t('checkout.details.name')}
                      <span>*</span>
                    </p>
                    <input type="text" defaultValue={user?.fullName} disabled />
                  </div>
                  <div className="checkout__input">
                    <p>
                      {t('checkout.details.address')}
                      <span>*</span>
                    </p>
                    <input type="text" defaultValue={user?.address} disabled />
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="checkout__input">
                        <p>
                          {t('checkout.details.phone')}
                          <span>*</span>
                        </p>
                        <input
                          type="text"
                          defaultValue={user?.phone}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="checkout__input">
                        <p>
                          Email<span>*</span>
                        </p>
                        <input
                          type="text"
                          defaultValue={user?.email}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="checkout__input">
                    <p>{t('checkout.details.note')}</p>
                    <input
                      type="text"
                      name="note"
                      value={note}
                      onChange={handleChangeNote}
                      placeholder={t('checkout.details.note1')}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="checkout__order">
                    <h4>{t('checkout.details.order')}</h4>
                    <div className="checkout__order__products">
                      {t('cart.product')} <span>{t('cart.pay')}</span>
                    </div>
                    <ul>
                      {cart &&
                        cart.map((item) => (
                          <li key={item.product.id}>
                            {item.product.name}{' '}
                            <span>
                              {String(item.total).replace(
                                /(.)(?=(\d{3})+$)/g,
                                '$1,'
                              )}{' '}
                              &#8363;
                            </span>
                          </li>
                        ))}
                    </ul>
                    <div className="checkout__order__subtotal">
                      {t('checkout.details.deliveryFee')}{' '}
                      <span>
                        {String(
                          valueDeliveryMethod ===
                            OrderDeliveryMethodEnum.YUM_YUM_EXPRESS
                            ? 0
                            : deliveryFee?.total || 0
                        ).replace(/(.)(?=(\d{3})+$)/g, '$1,')}{' '}
                        &#8363;
                      </span>
                    </div>
                    <div className="checkout__order__total">
                      {t('checkout.details.total')}{' '}
                      <span>
                        {String(total).replace(/(.)(?=(\d{3})+$)/g, '$1,')}{' '}
                        &#8363;
                      </span>
                    </div>
                    {user?.coin > 0 && (
                      <FormControlLabel
                        value="start"
                        control={
                          <Checkbox
                            color="error"
                            value={coinChecked}
                            onChange={() => setCoinChecked(!coinChecked)}
                            icon={<FavoriteBorder />}
                            checkedIcon={<Favorite />}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                          />
                        }
                        label={`${t('checkout.details.coin')} ${String(
                          user?.coin || 0
                        ).replace(/(.)(?=(\d{3})+$)/g, '$1,')} ${t(
                          'checkout.details.coin2'
                        )}`}
                        labelPlacement="start"
                        sx={{ ml: 'auto', width: '100%' }}
                      />
                    )}
                    <p>{t('checkout.details.note2')}</p>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        {t('checkout.details.deli1')}
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={valueDeliveryMethod}
                        onChange={handleChangeDeliveryMethod}
                      >
                        <FormControlLabel
                          value={OrderDeliveryMethodEnum.YUM_YUM_EXPRESS}
                          control={<Radio />}
                          label={t('checkout.details.deli2')}
                          disabled={
                            user?.address?.split(', ')[
                              user?.address?.split(', ')?.length - 1
                            ] !== 'Hồ Chí Minh' &&
                            user?.address?.split(', ')[
                              user?.address?.split(', ')?.length - 1
                            ] !== 'Bình Dương' &&
                            user?.address?.split(', ')[
                              user?.address?.split(', ')?.length - 1
                            ] !== 'Đồng Nai'
                          }
                        />
                        <FormControlLabel
                          value={OrderDeliveryMethodEnum.GHN}
                          control={<Radio />}
                          label={t('checkout.details.deli3')}
                        />
                      </RadioGroup>
                    </FormControl>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        {t('checkout.details.payment')}
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={value}
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value={'stripePayment'}
                          control={<Radio />}
                          label={t('checkout.details.payment1')}
                        />
                        <FormControlLabel
                          value={'momoPayment'}
                          control={<Radio />}
                          label={t('checkout.details.payment2')}
                        />
                        <FormControlLabel
                          value={'paymentOnDelivery'}
                          control={<Radio />}
                          label={t('checkout.details.payment3')}
                        />
                      </RadioGroup>
                    </FormControl>
                    <button onClick={onCheckout} className="site-btn">
                      {t('checkout.details.confirm')}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default memo(Checkout);
